import { Card } from "@/components/ui/card";
import TemplateNameEditor from "./TemplateNameEditor";
import TemplateActions from "./TemplateActions";
import UnsavedIndicator from "./UnsavedIndicator";
import { Template, TemplateFormData, TemplatePermissions } from "../types";
import { EditorMode } from "../types";

interface TemplateHeaderProps {
  template: Template | null;
  permissions: TemplatePermissions;
  actions: {
    save: (e: React.FormEvent) => void;
    delete: () => void;
    duplicate: () => void;
    test: (prompt: string) => void;
  };
  nameEditorState: {
    isEditingName: boolean;
    tempName: string;
    isSavingName: boolean;
    nameError: string | null;
    startEditingName: (currentName?: string) => void;
    cancelEditingName: (currentName?: string) => void;
    saveTemplateName: () => Promise<void>;
    updateTempName: (name: string) => void;
  };
  formData: TemplateFormData;
  baseTemplateId?: string | null;
  baseTemplate?: Template | null;
  isSaving: boolean;
  isDeleting: boolean;
  isUnsaved: boolean;
  mode: EditorMode;
}

const TemplateHeader = ({
  template,
  permissions,
  actions,
  nameEditorState,
  formData,
  baseTemplateId,
  baseTemplate,
  isSaving,
  isDeleting,
  isUnsaved,
  mode,
}: TemplateHeaderProps) => {
  return (
    <Card className="overflow-hidden rounded-b-none border-b-0 border border-border/50">
      <div className="relative border-l-4 border-brand-500 bg-gradient-to-r from-brand-50/20 to-transparent">
        <div className="p-4 sm:p-5">
          {/* Header with title */}
          <div className="flex items-start justify-between gap-3 sm:gap-4">
            <div className="flex-1 min-w-0">
              {/* Unsaved indicator */}
              <UnsavedIndicator isUnsaved={isUnsaved} />

              <div className="flex items-center gap-2">
                <TemplateNameEditor
                  templateName={formData.templateName}
                  nameEditorState={nameEditorState}
                  isSystem={template?.isSystem}
                  onUpdateTempName={nameEditorState.updateTempName}
                  onStartEditing={() => nameEditorState.startEditingName(formData.templateName)}
                  onCancelEditing={() => nameEditorState.cancelEditingName(formData.templateName)}
                  onSaveName={nameEditorState.saveTemplateName}
                />
              </div>
            </div>
          </div>

          {/* Base template info */}
          {baseTemplateId && baseTemplate && (
            <p className="text-sm text-muted-foreground mt-2">
              Создание шаблона на основе {baseTemplate.is_system ? "системного" : "пользовательского"}
            </p>
          )}

          {/* Actions section */}
          {(permissions.canEdit || permissions.canTest || permissions.canCopy) && (
            <TemplateActions
              mode={mode}
              template={template}
              formData={formData}
              onSave={actions.save}
              onDelete={actions.delete}
              onDuplicate={actions.duplicate}
              isSaving={isSaving}
              isDeleting={isDeleting}
              isUnsaved={isUnsaved}
              permissions={permissions}
            />
          )}
        </div>
      </div>
    </Card>
  );
};

export default TemplateHeader;
